import { useState } from 'react';

import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { WistiaVideo } from '#client/components/WistiaVideo';
import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import LessonDescriptionCard from '../../LessonDescriptionCard';

import { getLessonData } from '../../../cms/index';
import {
  IntroPageButtonsContainer,
  IntroPageContainer,
  IntroPageContent,
  IntroPageFooterButton,
  IntroPageHeader
} from './components';

const lessonsData = getLessonData();

const IntroPage = ({ onPrimaryClick }) => {
  const { lesson, step } = useParams();
  const [isPlayingVideo, setPlayingVideo] = useState(false);

  const lessonData = lessonsData.find((l) => l.url === lesson);
  const articleData = lessonData.steps.find((s) => s.url === step);

  // Events for Wistia Video
  const handlePlay = () => {
    setPlayingVideo(true);
  };

  const handlePause = () => {
    setPlayingVideo(false);
  };

  const handleEnd = () => {
    setPlayingVideo(false);
  };

  const {
    sizes: { isUpMd }
  } = useBreakpoints();

  return (
    <IntroPageContainer container direction="column" alignItems="center">
      <IntroPageHeader item>
        <LessonDescriptionCard
          title={articleData.title}
          description={articleData.description}
          onPrimaryClick={onPrimaryClick}
          onSecondaryClick={handlePlay}
          isPreview
        />
      </IntroPageHeader>
      <IntroPageContent item>
        <WistiaVideo
          isBordered
          key={articleData.content[0]?.url}
          id={articleData.content[0]?.url?.split('/').pop()}
          isPlaying={isPlayingVideo}
          onPlay={handlePlay}
          onPause={handlePause}
          onEnd={handleEnd}
        />
      </IntroPageContent>
      {!isUpMd && (
        <IntroPageButtonsContainer container item>
          <IntroPageFooterButton
            variant="outlined"
            color="secondary"
            size="large"
            onClick={handlePlay}
          >
            Watch video
          </IntroPageFooterButton>
          <IntroPageFooterButton
            onClick={onPrimaryClick}
            variant="contained"
            color="primary"
            size="large"
            // disabled={!hasWatchedVideo}
          >
            Continue
          </IntroPageFooterButton>
        </IntroPageButtonsContainer>
      )}
    </IntroPageContainer>
  );
};

IntroPage.propTypes = {
  onPrimaryClick: PropTypes.func
};

export default IntroPage;
